export default __webpack_public_path__ + "static/media/es-tfg-img.c8bbb498.webp";